import React from "react";
import { Input } from "src/components/ui/input";
import { Label } from "src/components/ui/label";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "src/components/ui/select";

interface AuditLogsFiltersProps {
  categoryFilter: string;
  setCategoryFilter: (value: string) => void;
  userFilter: string;
  setUserFilter: (value: string) => void;
}

export default function AuditLogsFilters({
  categoryFilter,
  setCategoryFilter,
  userFilter,
  setUserFilter
}: AuditLogsFiltersProps) {

  return (
    <div className="mb-6 flex flex-col sm:flex-row gap-4">
      <div className="flex-1">
        <Label htmlFor="user-filter" className="text-sm text-muted-foreground">
          Filter by user
        </Label>
        <Input
          id="user-filter"
          placeholder="Search by name or email..."
          value={userFilter}
          onChange={(e) => setUserFilter(e.target.value)}
          className="mt-1"
          autoComplete="off"
        />
      </div>
      <div className="w-full sm:w-48">
        <Label htmlFor="category-filter" className="text-sm text-muted-foreground">
          Filter by category
        </Label>
        <Select value={categoryFilter} onValueChange={setCategoryFilter}>
          <SelectTrigger className="mt-1">
            <SelectValue placeholder="All categories" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All categories</SelectItem>
            <SelectItem value="KNOWLEDGE_CATALOG">Knowledge Catalog</SelectItem>
            <SelectItem value="DIGEST">Digest</SelectItem>
            <SelectItem value="ALERT">Alert</SelectItem>
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
